// Training 1 — Concept CLC Course Data
// This file contains the course structure for Training 1

import { Module } from './courseData'

export const conceptClcModules: Module[] = [
  {
    id: 'introducere-concept-clc',
    title: 'Modul 1 — Introducere în Conceptul CLC',
    icon: 'lightbulb',
    description:
      'Descoperă ecosistemul agenției și înțelege cum funcționează sistemul',
    lessons: [
      {
        id: 'introducere-agentie',
        title: 'Introducere Agenție',
        duration: '20 min',
        description:
          'Prezentarea generală a agenției și a valorilor fundamentale',
        sections: [
          {
            id: 'obiectiv',
            title: 'Obiectivul lecției',
            emoji: '🎯',
            number: '0️⃣',
            content:
              'În această lecție vei descoperi ecosistemul agenției Cautlocuință.ro și vei înțelege cum funcționează sistemul care te va susține în cariera ta imobiliară.\n\nVei învăța:\n\n• Ce înseamnă "ecosistemul agenției" și cum te ajută să reușești\n• Ce ne face diferiți față de alte agenții din piață\n• Ce vei învăța în acest curs complet și cum te va transforma',
            type: 'text',
          },
          {
            id: 'introducere',
            title: 'Bine ai venit în ecosistemul agenției',
            emoji: '🧭',
            number: '1️⃣',
            content:
              'Bine ai venit în ecosistemul agenției Cautlocuință.ro, locul unde redefinim complet modul de a practica imobiliarele în România. Aici, am creat un sistem care nu se bazează pe întâmplare, ci pe strategie, performanță și suport constant.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Agenție imobiliară modernă cu clădiri rezidențiale',
            type: 'text',
          },
          {
            id: 'ecosistem',
            title: 'Ce este „ecosistemul agenției"',
            emoji: '🌐',
            number: '2️⃣',
            content:
              'Când spunem «ecosistem», ne referim la o rețea digitală completă, formată din:\n\n• Platforma pro.cautlocuinta.ro, unde gestionezi activitatea ta zilnică\n• Echipa de suport 7/7, mereu pregătită să te ajute\n• Sistemul de traininguri pas cu pas, care te duce de la debutant la profesionist\n• Procesul de comisionare progresivă, care îți crește câștigul odată cu rezultatele\n\nÎn acest ecosistem, nu ești niciodată singur. Ai alături o echipă, un sistem, un plan — și un obiectiv comun: performanța.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Platformă digitală imobiliară cu proprietăți',
            type: 'text',
          },
          {
            id: 'diferente',
            title: 'Ce ne face diferiți față de alte agenții',
            emoji: '🚀',
            number: '3️⃣',
            content:
              'Obiectivul nostru este simplu: să fim diferiți și mai buni. Agenția nu vinde doar servicii imobiliare, ci oferă un model de carieră. Aici înveți, evoluezi și câștigi în funcție de performanța ta, într-un sistem corect, digitalizat și transparent.\n\nDacă alții au reușit să ajungă la rezultate extraordinare în doar câteva luni, și tu poți face același lucru. Tot ce trebuie să faci este să urmezi procesul și să aplici ce înveți.',
            image:
              'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=1200&h=600&fit=crop',
            imageAlt: 'Echipă de agenți imobiliari profesioniști',
            quote:
              'La CautLocuinta.ro, fiecare pas te aduce mai aproape de succes.',
            type: 'text',
          },
          {
            id: 'video',
            title: 'Urmărește prezentarea video',
            content:
              'În acest video, avatarul AI îți explică pas cu pas cum funcționează ecosistemul agenției CautLocuința.ro și cum poți profita de toate resursele disponibile pentru a-ți accelera cariera.',
            type: 'video',
          },
          {
            id: 'invata',
            title: 'Ce vei învăța în acest curs',
            emoji: '💡',
            number: '4️⃣',
            content:
              'În următoarele lecții vei descoperi:\n\n• Cum funcționează sistemul agenției și procesul de tranzacționare\n• Cum sunt structurate comisioanele și nivelele de carieră\n• Ce instrumente digitale vei folosi zi de zi\n• Cum te poți transforma dintr-un simplu agent într-un adevărat consultant imobiliar\n\nȚine minte: nu trebuie să știi totul de la început. Trebuie doar să începi și să fii consecvent. Restul vine natural.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Dashboard CRM imobiliar cu statistici',
            type: 'text',
          },
          {
            id: 'concluzie',
            title: 'Concluzie',
            emoji: '🌱',
            number: '5️⃣',
            content:
              'Ecosistemul agenției Cautlocuință.ro este locul unde educația, tehnologia și performanța se întâlnesc. Fiecare lecție te duce mai aproape de cariera la care aspiri. De azi, faci parte dintr-un sistem care funcționează — și care te poate duce exact acolo unde vrei să ajungi.\n\nNu uita: la agenția noastră, succesul tău este și succesul nostru.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Clădiri rezidențiale moderne',
            type: 'conclusion',
          },
        ],
      },
      {
        id: 'rezultatele-agentiei',
        title: 'Rezultatele Agenției',
        duration: '15 min',
        description: 'Analiza performanțelor și rezultatelor agenției',
        sections: [
          {
            id: 'obiectiv',
            title: 'Obiectivul lecției',
            emoji: '🎯',
            number: '0️⃣',
            content:
              'În această lecție vei descoperi rezultatele reale ale agenției și ale agenților care au aplicat sistemul nostru.\n\nVei învăța:\n\n• Ce înseamnă "tranzacție închisă" și cum se măsoară succesul\n• Care sunt recordurile agenților din ecosistem\n• Ce demonstrează aceste rezultate despre sistem\n• Cum poți și tu să atingi performanțe similare',
            type: 'text',
          },
          {
            id: 'introducere',
            title: '7 ani de construcție, inovație și rezultate',
            emoji: '🏗️',
            number: '1️⃣',
            content:
              'În cei 7 ani de activitate, agenția Cautlocuință.ro a demonstrat că performanța în imobiliare nu ține de noroc, ci de disciplină, metodă și consistență. Am crescut pas cu pas, am învățat din fiecare provocare și am construit un sistem care astăzi livrează rezultate constante și verificabile.\n\n🎯 7 ani de muncă, peste 1.000 de tranzacții închise și zeci de agenți care au trecut de la zero la performanță în timp record.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Portofoliu de proprietăți imobiliare',
            type: 'text',
          },
          {
            id: 'tranzactie-inchisa',
            title: 'Ce înseamnă „tranzacție închisă"',
            emoji: '💼',
            number: '2️⃣',
            content:
              'În ecosistemul agenției, fiecare succes se numește tranzacție închisă – adică o închiriere sau vânzare finalizată complet, validată și arhivată în sistemul digital. Arhivele de tranzacții închise sunt dovada reală a performanței fiecărui agent. Ele nu sunt simple rapoarte – sunt mărturii ale reușitelor.\n\nPrima arhivă «tranzacție închisă» a fost înregistrată chiar în prima zi de activitate, cu primul comision obținut instant.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Contract semnat și chei de apartament',
            type: 'text',
          },
          {
            id: 'recorduri',
            title: 'Recordurile agenților din ecosistem',
            emoji: '🚀',
            number: '3️⃣',
            content:
              'Performanțele agenților noștri arată cât de puternic este sistemul agenției. Iată câteva dintre recordurile care definesc cultura noastră:',
            type: 'records',
            records: [
              {
                icon: '🏅',
                category: 'Cel mai rapid comision',
                record: '✅ În prima zi de la start activitate',
                observation:
                  'Primul comision obținut imediat după training, pe o arhivă de închiriere validată.',
              },
              {
                icon: '🥇',
                category: 'Cele mai multe tranzacții de închiriere într-o lună',
                record: '16 tranzacții (Locul 1), 🥈 12 tranzacții (Locul 2)',
                observation:
                  'Record stabilit în prima lună de activitate de către agenți noi.',
              },
              {
                icon: '🏆',
                category: 'Cea mai rapidă tranzacție de vânzare',
                record: 'Finalizată în prima zi după trainingul de vânzare',
                observation: 'Demonstrează eficiența procesului de training.',
              },
              {
                icon: '💶',
                category: 'Cel mai mare comision pe închiriere',
                record: '10.000 €',
                observation:
                  'Obținut dintr-o singură tranzacție, în urma unei închirieri corporate.',
              },
              {
                icon: '💰',
                category: 'Cel mai mare comision pe vânzare',
                record: '38.000 €',
                observation:
                  'Dintr-o singură tranzacție de vânzare finalizată integral.',
              },
              {
                icon: '🏗️',
                category: 'Cele mai multe tranzacții de vânzare într-o lună',
                record: '11 tranzacții, 16 proprietăți vândute',
                observation:
                  'Performanță atinsă prin aplicarea completă a metodologiei agenției.',
              },
            ],
          },
          {
            id: 'ce-arata',
            title: 'Ce ne arată aceste rezultate',
            emoji: '🌟',
            number: '4️⃣',
            content:
              'Aceste recorduri nu sunt doar cifre, ci repere de performanță. Ele confirmă trei lucruri importante despre agenție:\n\n1️⃣ Sistemul funcționează. Nu contează experiența anterioară — dacă urmezi procesul, ai rezultate.\n\n2️⃣ Trainingul face diferența. Cei care finalizează complet modulele de instruire au cele mai rapide tranzacții.\n\n3️⃣ Disciplina bate talentul. Agenții constanți, care lucrează zilnic și aplică regulile, depășesc orice record existent.\n\nDacă alții au reușit să obțină comisioane de 10.000 sau 38.000 de euro, tu de ce nu ai putea? Totul începe cu primul pas: implicare, învățare și acțiune zilnică.',
            image:
              'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&h=600&fit=crop',
            imageAlt: 'Creștere și performanță',
            type: 'conclusion',
          },
        ],
      },
      {
        id: 'scara-performantei',
        title: 'Scara Performanței',
        duration: '20 min',
        description:
          'Sistemul de comisionare lunară progresivă și zonele de performanță',
        sections: [
          {
            id: 'obiectiv',
            title: 'Obiectivul lecției',
            emoji: '🎯',
            number: '0️⃣',
            content:
              'În această lecție vei descoperi Scara Performanței – sistemul de comisionare progresivă care recompensează rezultatele tale constante.\n\nVei învăța:\n\n• Ce este Scara Performanței și cum funcționează sistemul lunar\n• Cum se calculează comisionul în funcție de performanța ta\n• Cum să progresezi către zonele verzi de comisionare\n• Cum să folosești calculatorul de performanță pentru a-ți planifica veniturile',
            type: 'text',
          },
          {
            id: 'ce-este',
            title: 'Ce este Scara Performanței',
            emoji: '📈',
            number: '1️⃣',
            content:
              '«Scara Performanței» este grila lunară de comisionare a agenției Cautlocuință.ro, creată pentru a recompensa consultanții imobiliari care livrează rezultate constante.\n\nComisionul tău lunar se calculează în funcție de suma totală a comisioanelor încasate într-o lună calendaristică, între data de 1 și 1 a fiecărei luni.\n\n💡 Nu contează dacă tranzacțiile sunt din chirii, vânzări sau mixte – sistemul adună toate comisioanele realizate, iar la final de lună se stabilește procentul aferent nivelului tău.',
            image:
              'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=600&fit=crop',
            imageAlt: 'Calculator și grafice de performanță imobiliară',
            type: 'text',
          },
          {
            id: 'cum-functioneaza',
            title: 'Cum funcționează sistemul lunar',
            emoji: '🎯',
            number: '2️⃣',
            content:
              'În fiecare lună, toate comisioanele generate de tine (din închirieri + vânzări) sunt adunate. Totalul determină zona de performanță în care te încadrezi.\n\nFiecare zonă are un procent de comision aferent. Cu cât totalul lunar este mai mare, cu atât procentul tău crește.\n\nAstfel, agenția oferă bonusuri progresive celor care performează constant, motivând fiecare agent să își depășească propriul record.',
            image:
              'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=1200&h=600&fit=crop',
            imageAlt: 'Grafic ascendent cu statistici imobiliare',
            quote:
              'Performanța nu este un scop, ci un obicei care se construiește lunar.',
            type: 'text',
          },
          {
            id: 'grila-oficiala',
            title: 'Scara Performanței – Grila oficială',
            emoji: '📊',
            number: '3️⃣',
            content:
              'Grila de mai jos arată clar cum evoluează procentul de comision lunar în funcție de totalul generat. Fiecare zonă are un cod de culoare și un nivel de performanță specific.',
            type: 'performance-grid',
          },
          {
            id: 'calculator',
            title: 'Calculator de performanță',
            emoji: '💰',
            number: '4️⃣',
            content:
              'Folosește calculatorul de mai jos pentru a vedea în ce zonă te afli și care este comisionul tău lunar în funcție de performanța ta.',
            type: 'performance-calculator',
          },
          {
            id: 'video',
            title: 'Urmărește prezentarea video',
            content:
              'În acest video, avatarul AI îți explică în detaliu cum funcționează Scara Performanței, cum se calculează comisionul lunar și cum poți progresa către zonele verzi.',
            type: 'video',
          },
          {
            id: 'concluzie',
            title: 'Concluzie',
            emoji: '🌱',
            number: '6️⃣',
            content:
              'Scara Performanței este barometrul activității tale. Cu cât ești mai constant, cu atât urci mai rapid în zonele verzi. Agenția îți oferă toate resursele – tu trebuie doar să fii consecvent.\n\n💬 Ține minte: performanța nu este un scop, ci un obicei. Fiecare lună este o nouă șansă de a urca mai sus pe Scara Performanței.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Clădiri rezidențiale de lux',
            type: 'conclusion',
          },
        ],
      },
    ],
  },
  {
    id: 'structura-cultura-clc',
    title: 'Modul 2 — Structura și Cultura CLC',
    icon: 'users',
    description:
      'Parcursul profesional, metodologia de lucru și sistemul de suport',
    lessons: [
      {
        id: 'nivele-de-cariera',
        title: 'Nivele de carieră',
        duration: '22 min',
        description: 'Parcursul profesional și oportunitățile de avansare',
        sections: [
          {
            id: 'obiectiv',
            title: 'Obiectivul lecției',
            emoji: '🎯',
            number: '0️⃣',
            content:
              'În această lecție vei descoperi sistemul de carieră al agenției și cum poți avansa de la Trainee la Selling Master.\n\nVei învăța:\n\n• Ce reprezintă nivelele de carieră și cum funcționează sistemul\n• Care sunt etapele de carieră și cerințele pentru fiecare nivel\n• Cum se deblochează listele de proprietari și clienți\n• Cum să folosești calculatorul de nivel pentru a-ți planifica progresul',
            type: 'text',
          },
          {
            id: 'ce-reprezinta',
            title: 'Ce reprezintă nivelele de carieră',
            emoji: '🎯',
            number: '1️⃣',
            content:
              'În agenția Cautlocuință.ro, succesul nu este doar despre comisioane, ci și despre evoluția ta profesională.\n\nFiecare agent nou intră în ecosistem și urcă pe o scară de carieră clar definită, bazată pe performanță și rezultate reale.\n\nFiecare tranzacție contează. Cu fiecare etapă parcursă, îți deblochezi noi privilegii, leaduri și un statut profesional superior.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Agent imobiliar prezentând proprietăți clienților',
            type: 'text',
          },
          {
            id: 'cum-functioneaza',
            title: 'Cum funcționează sistemul de carieră',
            emoji: '⚙️',
            number: '2️⃣',
            content:
              'Fiecare agent începe ca Trainee, parcurgând trainingul de inițiere. După finalizarea procesului de onboarding și primele cursuri, primește acces la listele de închiriere și devine Rental Closer.\n\nDe aici începe jocul performanței: fiecare tranzacție încheiată îți deschide un nou nivel de carieră.\n\n💡 Sistemul este transparent și meritocratic – avansezi prin rezultate reale, nu prin vechime. La prima închiriere finalizată, primești acces la liste de cumpărători. La 3 închirieri finalizate, se deblochează și listele de proprietari.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Portofoliu de proprietăți rezidențiale',
            type: 'text',
          },
          {
            id: 'tabel-etape',
            title: 'Etapele de carieră – tabel oficial',
            emoji: '📊',
            number: '3️⃣',
            content:
              'Fiecare nivel reprezintă un pas clar în evoluția ta profesională. Tabelul de mai jos prezintă toate nivelele de carieră și cerințele pentru fiecare.',
            type: 'career-table',
            careerLevels: [
              {
                level: 'Trainee',
                rentals: '--',
                sales: '--',
                description:
                  'Etapa de formare – agentul parcurge trainingurile și procesul de onboarding.',
                color: 'from-gray-100 to-gray-200',
              },
              {
                level: 'Rental Closer',
                rentals: '0–1',
                sales: '0',
                description:
                  'Primește acces la listele de închiriere și gestionează primele tranzacții.',
                color: 'from-blue-100 to-blue-200',
              },
              {
                level: 'Rental Buyer',
                rentals: '1+',
                sales: '0',
                description:
                  'După prima tranzacție închisă, primești leaduri de cumpărători.',
                color: 'from-blue-200 to-blue-300',
              },
              {
                level: 'Selling Closer',
                rentals: '3+',
                sales: '1',
                description:
                  'Cu minim 3 închirieri finalizate, se deblochează listele de proprietari. Poate gestiona cumpărători și proprietari pe segmentul de vânzare.',
                color: 'from-green-100 to-green-200',
              },
              {
                level: 'Selling Broker',
                rentals: '3+',
                sales: '4',
                description:
                  'Începe să lucreze cu portofolii complexe și primește leaduri premium.',
                color: 'from-green-200 to-green-300',
              },
              {
                level: 'Selling Senior',
                rentals: '3+',
                sales: '9',
                description:
                  'Nivel avansat – agent stabil, cu portofoliu personal consistent.',
                color: 'from-green-300 to-green-400',
              },
              {
                level: 'Selling Master',
                rentals: '3+',
                sales: '10+',
                description:
                  'Nivel de top – agentul devine mentor și poate coordona alți agenți.',
                color: 'from-green-400 to-green-500',
              },
            ],
          },
          {
            id: 'cum-avansezi',
            title: 'Cum avansezi în carieră',
            emoji: '🔹',
            number: '4️⃣',
            content:
              'Fiecare nivel de carieră se deblochează automat când îndeplinești cerințele. Iată pașii clari de progres:',
            type: 'career-timeline',
            timelineSteps: [
              {
                from: 'Trainee',
                to: 'Rental Closer',
                requirement: 'Finalizarea onboardingului',
                description:
                  'După completarea trainingurilor inițiale, primești acces la primele liste de închiriere.',
              },
              {
                from: 'Rental Closer',
                to: 'Rental Buyer',
                requirement: '1 închiriere finalizată',
                description:
                  'Prima ta tranzacție închisă îți deschide accesul la leaduri de cumpărători.',
              },
              {
                from: 'Rental Buyer',
                to: 'Selling Closer',
                requirement: '3 închirieri finalizate',
                description:
                  'Cu minim 3 închirieri finalizate, se deblochează listele de proprietari. Demonstrezi că ai experiența necesară pentru a gestiona atât cumpărători, cât și proprietari pe segmentul de vânzări.',
              },
              {
                from: 'Selling Closer',
                to: 'Selling Broker',
                requirement: '3 închirieri + 4 vânzări',
                description:
                  'Devii eligibil pentru portofolii complexe și leaduri premium.',
              },
              {
                from: 'Selling Broker',
                to: 'Selling Senior',
                requirement: '3 închirieri + 9 vânzări',
                description:
                  'Atingi nivelul avansat și primești recunoaștere ca agent stabil.',
              },
              {
                from: 'Selling Senior',
                to: 'Selling Master',
                requirement: '3 închirieri + 10+ vânzări',
                description:
                  'Devii mentor și poți coordona alți agenți din echipă.',
              },
            ],
          },
          {
            id: 'deblocare-liste',
            title: 'Sistemul de deblocare a listelor',
            emoji: '🔓',
            number: '5️⃣',
            content:
              'Fiecare nivel de carieră deblochează noi tipuri de liste și oportunități:\n\n🏠 Rental Closer: Acces la liste de închiriere\n\n🔑 Rental Buyer (1 închiriere finalizată): Se deblochează listele de cumpărători\n\n🎯 Selling Closer (3 închirieri finalizate): Se deblochează listele de proprietari pentru vânzări\n\nAcest sistem progresiv asigură că agenții sunt pregătiți pentru fiecare etapă și au experiența necesară pentru a gestiona clienți mai complexi. Cu 3 închirieri finalizate, demonstrezi că ai înțeles procesul și ești pregătit să gestionezi și proprietari pe segmentul de vânzare.',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Sistem de progresie și deblocare',
            type: 'text',
          },
          {
            id: 'calculator',
            title: 'Calculator de nivel de carieră',
            emoji: '💼',
            number: '6️⃣',
            content:
              'Completează mai jos numărul de tranzacții de închiriere și vânzare realizate pentru a afla nivelul tău actual de carieră.',
            type: 'career-calculator',
          },
          {
            id: 'video',
            title: 'Urmărește video-ul despre nivelele de carieră',
            content:
              'În acest video, avatarul AI explică pas cu pas cum funcționează nivelele de carieră, cum se face trecerea între ele și ce beneficii ai la fiecare etapă.',
            type: 'video',
          },
          {
            id: 'concluzie',
            title: 'Concluzie',
            emoji: '🌱',
            number: '8️⃣',
            content:
              'Nivelele de carieră definesc progresul tău real în agenție. Fiecare etapă este o recompensă pentru rezultate. Aici nu există limite impuse – doar pași clari și obiective măsurabile.\n\n💡 Ține minte: în agenția noastră, nu avansezi prin vechime, ci prin performanță. Fiecare tranzacție închisă este o treaptă către următorul nivel. La 1 închiriere se deblochează listele de cumpărători, iar la 3 închirieri se deblochează și listele de proprietari – pregătindu-te complet pentru segmentul de vânzări.',
            image:
              'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1200&h=600&fit=crop',
            imageAlt: 'Echipă motivată privind spre viitor',
            type: 'conclusion',
          },
        ],
      },
      {
        id: 'reteta-clc',
        title: 'Rețeta CLC',
        duration: '25 min',
        description: 'Formula de succes și metodologia de lucru',
        sections: [
          {
            id: 'obiectiv',
            title: 'Obiectivul lecției',
            emoji: '🎯',
            number: '0️⃣',
            content:
              'În această lecție vei descoperi „Rețeta Cautlocuință.ro" – sistemul complet care te transformă dintr-un agent dependent într-un consultant independent și profitabil.\n\nVei învăța:\n\n• Ce înseamnă „rețeta" și cum te transformă în agent independent\n• Cum aplici: Onboarding → Liste → Promovare → Leaduri → Tranzacție step-by-step → Legal & Suport 7/7\n• Cum folosești corect resursele: AI asistent, live support, traininguri',
            type: 'text',
          },
          {
            id: 'onboarding',
            title: 'Onboarding & Inițiere – Te echipăm pentru joc',
            emoji: '🚀',
            number: '1️⃣',
            content:
              'Primul pas în rețeta Cautlocuință.ro este onboarding-ul complet. Aici te echipăm cu tot ce ai nevoie pentru a începe să produci rezultate de la prima zi.\n\nUn onboarding bine făcut înseamnă start rapid și siguranță în activitatea zilnică. Bifează fiecare element din checklist-ul de mai jos pentru a te asigura că ești pregătit complet.',
            type: 'checklist',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Agent imobiliar în training',
          },
          {
            id: 'liste-proprietari',
            title: 'Liste de proprietari – Prospectarea inteligentă',
            emoji: '📋',
            number: '2️⃣',
            content:
              'Listele de proprietari sunt motorul tău de venit. Agenția îți oferă acces zilnic la liste curate, verificate și gata de prospectat.\n\nDe ce contează?\n\n• Economisești ore de research repetitiv\n• Proprietatea rămâne „a ta" (comision proprietar pentru agentul care a prospectat)\n• Șanse de venit de la primul apel\n\nFluxul este simplu: Apel → Calificare → Colaborare → Vizionare',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Liste de proprietăți imobiliare',
          },
          {
            id: 'promovare',
            title: 'Promovare nelimitată – Investim în succesul tău',
            emoji: '📢',
            number: '3️⃣',
            content:
              'Agenția plătește promovarea pentru oricâte proprietăți aduci. Fără costuri pentru agent.\n\nFiecare proprietate pe care o aduci în portofoliu beneficiază automat de:\n\n• Campanii plătite pe Facebook și Google\n• Promovare pe platformele imobiliare premium\n• Optimizare SEO și vizibilitate maximă\n• Reach extins și leaduri calificate\n\n💡 Tu aduci proprietatea, noi o promovăm profesional. Investim în succesul tău.',
            type: 'text',
            image:
              'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop',
            imageAlt: 'Anunțuri imobiliare online',
          },
          {
            id: 'clienti-leaduri',
            title: 'Clienți & Liste de clienți activi – A doua sursă de venit',
            emoji: '👥',
            number: '4️⃣',
            content:
              'După ce finalizezi prima închiriere, se deblochează accesul la liste de cumpărători – a doua ta sursă majoră de venit.\n\nCum funcționează alocarea leadurilor:\n\n• Clientul generat de campanii este asignat agentului cu proprietatea de interes\n• După prima închiriere finalizată → primești acces la liste de cumpărători\n• Califici cererea, trimiți potriviri (intern + colaborări), programezi vizionări\n\n💰 Prestăm pe comision pentru proprietari și clienți – câștigi de pe ambele părți.',
            image:
              'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1200&h=600&fit=crop',
            imageAlt: 'Clienți și leaduri',
          },
          {
            id: 'asistenta-proces',
            title: 'Asistență pe tot procesul – Tu aduci DA-ul, noi închidem',
            emoji: '🤝',
            number: '5️⃣',
            content:
              'Nu ești niciodată singur în procesul de tranzacționare. Echipa de suport te asistă la fiecare pas critic:\n\n1. Negociere & ofertare asistate\n2. Verificare acte & dosar de vânzare\n3. Organizare semnare la notariat\n4. Facturare & închidere în platformă\n\n💡 Când simți că arde, intră pe Live Support – preluăm și închidem împreună.',
            image:
              'https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1200&h=600&fit=crop',
            imageAlt: 'Asistență proces',
          },
          {
            id: 'suport-7-7',
            title: 'Suport 7 din 7 – AI + Live Support',
            emoji: '💬',
            number: '6️⃣',
            content:
              'Suportul este real și pro-activ. Dacă tu nu produci, agenția pierde – de aceea investim în suportul tău constant.\n\nAi acces la:\n\n• Asistent AI pentru întrebări rapide, ghiduri și proceduri\n• Live Support pe departamente: tehnic, imobiliar, legal, fiscal\n• Răspuns rapid și soluții concrete\n• Disponibil 7 zile din 7\n\n🎯 Scopul: să elimini blocajele și să continui să produci rezultate.',
            image:
              'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=600&fit=crop',
            imageAlt: 'Suport 7/7',
          },
          {
            id: 'metodologie-step-by-step',
            title: 'Metodologia „Tranzacție Step by Step"',
            emoji: '📊',
            number: '7️⃣',
            content:
              'Metodă testată în 7 ani. Respectă pașii → rezultatul vine.\n\nFiecare tranzacție urmează un proces clar, cu 9 pași bine definiți. Această metodologie elimină haosul și te ghidează pas cu pas către închiderea tranzacției.',
            type: 'timeline',
          },
          {
            id: 'traininguri',
            title: 'Traininguri dedicate, constante',
            emoji: '📚',
            number: '8️⃣',
            content:
              'Programul de training este continuu și acoperă toate domeniile esențiale:\n\n• Training de inițiere pentru agenți noi\n• Module avansate de vânzare complexă\n• Traininguri specializate: terenuri, spații comerciale, investiții B2B\n• Evaluări și certificări interne\n\n✅ Consistența crește rata de conversie. Cu cât înveți mai mult, cu atât vinzi mai mult.',
            image:
              'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=1200&h=600&fit=crop',
            imageAlt: 'Traininguri dedicate',
          },
          {
            id: 'legal',
            title: 'Legal – Scutul tău juridic',
            emoji: '⚖️',
            number: '9️⃣',
            content:
              'Departamentul legal te protejează în situații complexe și previne problemele înainte să apară.\n\nCe acoperim:\n\n• Clauze speciale în contracte\n• Situații de întârzieri sau neplată\n• Cazuri particulare la tranzacții\n• Consultanță preventivă\n\n⚠️ Spune-ne devreme → prevenim elegant, nu stingem incendii.',
            image:
              'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200&h=600&fit=crop',
            imageAlt: 'Suport legal',
          },
          {
            id: 'video',
            title: 'Urmărește prezentarea video a rețetei',
            content:
              'Avatarul AI explică pas cu pas cum aplici rețeta în activitatea zilnică. Vei vedea cum se leagă toate elementele și cum le folosești eficient.',
            type: 'video',
          },
          {
            id: 'harta-completa',
            title: 'Totul pe o singură hartă',
            emoji: '🗺️',
            number: '🔟',
            content:
              'Schema de mai jos conectează toate elementele rețetei Cautlocuință.ro într-un flux logic și ușor de urmărit.',
            type: 'flowchart',
          },
          {
            id: 'resurse',
            title: 'Resurse & șabloane',
            emoji: '📦',
            number: '1️⃣1️⃣',
            content:
              'Descarcă resursele esențiale pentru a aplica rețeta în activitatea ta zilnică:',
            type: 'resources',
          },
          {
            id: 'concluzie',
            title: 'Concluzie',
            emoji: '🎯',
            number: '1️⃣2️⃣',
            content:
              'Rețeta Cautlocuință.ro = echipare + leaduri + promovare + suport 7/7 + metodă + training + legal.\n\nAplică tot, pas cu pas. Scopul: să devii independent și profitabil.\n\nDe mâine, folosește fiecare piesă din rețetă în activitatea ta. Nu trebuie să știi totul perfect – trebuie doar să începi și să aplici constant.\n\n💡 Ține minte: succesul vine din aplicarea consecventă a sistemului, nu din inspirație sau noroc.',
            image:
              'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=600&fit=crop',
            imageAlt: 'Echipă de succes',
            type: 'conclusion',
          },
        ],
      },
      {
        id: 'suport-individual',
        title: 'Suport Individual CLC',
        duration: '25 min',
        description:
          'Sistemul unic de asistență personalizată 7/7 pentru fiecare agent',
        sections: [
          {
            id: 'obiectiv',
            title: 'Obiectivul lecției',
            emoji: '🎯',
            number: '0️⃣',
            content:
              'În această lecție vei descoperi Suportul Individual CLC – sistemul unic în România care transformă modul în care agenții imobiliari lucrează și evoluează.\n\nVei învăța:\n\n• Ce este Suportul Individual CLC și de ce este unic\n• Cum funcționează grupurile de suport și comunitatea WhatsApp Business\n• Cum comunici corect cu echipa de suport și ce beneficii aduce acest sistem',
            type: 'text',
          },
          {
            id: 'ce-este',
            title: 'Ce este Suportul Individual CLC',
            emoji: '🧭',
            number: '1️⃣',
            content:
              'La agenția Cautlocuința.ro, fiecare agent are parte de asistență personalizată 7/7 printr-un sistem unic în România – Suportul Individual CLC.\n\nEste o combinație între comunitate, mentorat și asistență operațională în timp real, gândită să accelereze dezvoltarea fiecărui agent.\n\n💡 Este primul sistem de learning & development aplicat direct în activitatea zilnică a unui consultant imobiliar.',
            image:
              'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=1200&h=600&fit=crop',
            imageAlt: 'Sistem de suport CLC',
            type: 'text',
          },
          {
            id: 'cum-functioneaza',
            title: 'Cum funcționează sistemul',
            emoji: '🔹',
            number: '2️⃣',
            content:
              'Fiecare agent este adăugat în:\n\n• Grupurile comunității oficiale WhatsApp Business Cautlocuința.ro – noutăți, proceduri, anunțuri\n• Grupul individual de suport CLC – comunicare directă cu echipa centrală\n\nÎn grupul individual se află:\n\n– Membri ai Boardului agenției (decizionali)\n– Reprezentanți ai departamentelor tehnic, juridic, imobiliar, fiscal și AI\n– Agentul însuși\n\n💬 Acest grup este canalul principal pentru orice întrebare, problemă sau nelămurire.',
            image:
              'https://images.unsplash.com/photo-1611746872915-64382b5c76da?w=1200&h=600&fit=crop',
            imageAlt: 'Comunicare WhatsApp Business',
            type: 'text',
          },
          {
            id: 'ce-se-discuta',
            title: 'Ce se discută în grupul de suport',
            emoji: '💬',
            number: '3️⃣',
            content:
              'Grupul individual de suport este locul unde comunici direct cu echipa pentru orice situație operațională sau nelămurire.',
            type: 'support-accordion',
          },
          {
            id: 'scopul-beneficii',
            title: 'Scopul și beneficiile sistemului',
            emoji: '🌱',
            number: '4️⃣',
            content:
              'Scopul Suportului Individual este ridicarea rapidă a nivelului de calitate, experiență și profesionalism al fiecărui agent.\n\nAgenția a înlocuit modelul "descurcă-te singur" cu un model de dezvoltare asistată individual.\n\n🧠 Cu cât comunici mai mult cu echipa, cu atât înveți mai repede și greșești mai puțin. Succesul tău este o muncă de echipă.',
            image:
              'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=600&fit=crop',
            imageAlt: 'Echipă colaborând',
            type: 'text',
          },
          {
            id: 'reguli-comunicare',
            title: 'Reguli de comunicare în grupul CLC',
            emoji: '⚙️',
            number: '5️⃣',
            content:
              'Pentru ca sistemul de suport să funcționeze optim, este important să respecți câteva reguli simple de comunicare:',
            type: 'communication-checklist',
          },
          {
            id: 'de-ce-unic',
            title: 'De ce este unic acest sistem',
            emoji: '🌟',
            number: '6️⃣',
            content:
              'Agenția Cautlocuința.ro este prima din România care a implementat un sistem complet de Suport Individual CLC – un mix între training personalizat, mentoring și management de performanță.\n\nÎn timp ce alte companii îți oferă un manual, noi îți oferim o echipă reală care te învață zilnic.\n\nSuccesul tău nu depinde doar de tine – ci și de oamenii care te susțin.',
            image:
              'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=600&fit=crop',
            imageAlt: 'Echipă de suport dedicată',
            type: 'text',
          },
          {
            id: 'video',
            title: 'Urmărește prezentarea video',
            content:
              'În acest video, avatarul AI explică pas cu pas cum funcționează Suportul Individual CLC și cum să comunici eficient cu echipa.',
            type: 'video',
          },
        ],
      },
    ],
  },
]
